// AI Deep Analysis — uses the buyer's Groq API key (from Settings) for the deep-dive.
// The PWA works fully without this; the key is optional.

import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiDeepAnalysis(
  ideaDescription: string,
  scores: any,
  onStream: (chunk: string) => void
): Promise<void> {
  const system = `You are a startup advisor and product strategist. Be brutally honest about flaws. Identify hidden flaws. Suggest 3 specific niche angles to differentiate. Estimate realistic first-month revenue. Recommend first 3 marketing channels. Use Markdown.`;
  try {
    await streamGroq({
      messages: [
        { role: 'system', content: system },
        { role: 'user', content: `Idea: ${ideaDescription}\n\nScores: ${JSON.stringify(scores)}\n\nProvide deep analysis.` },
      ],
      temperature: 0.4,
      onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) {
      onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key from console.groq.com/keys. The core logic above works fully without it.');
      return;
    }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
